import { IconType } from '~/v1/components/icons/icon.interfaces';
import { isInternalLink } from '~/v1/utils/isInternalLink';

export function getLinkIcon(href: string) {
  if (href.startsWith('mailto:')) {
    return IconType.Envelope;
  }
  if (href.endsWith('.pdf')) {
    return IconType.Pdf;
  }
  if (isInternalLink(href)) {
    return IconType.ExpandingArrowRight;
  }
  return IconType.ExpandingArrowDiagonal;
}
